const populateData = ({ commit, rootState }, viewsData) => {
  const images = viewsData.section_images;
  images.sort((a,b) => {
    if (parseInt(a.filter_id, 10) === parseInt(b.filter_id, 10)) {
      return parseInt(a.imageset_id, 10) - parseInt(b.imageset_id, 10);
    }
    return parseInt(a.filter_id, 10) - parseInt(b.filter_id, 10)
  });

  const viewGroups = [];
  images.forEach((image) => {
    const existingViewGroup = viewGroups.find(view => view.filter_id === image.filter_id)
    if (!existingViewGroup) {
      const newObj = {
        floor: parseInt(image.type, 10),
        viewType: image.title,
        filter_id: image.filter_id,
        images: []
      };

      const imageObj = {
        id: parseInt(image.imageset_id, 10),
        src: rootState.project.assetsUrl + image.url,
        caption: image.caption,
        isPano: false
      };
      newObj.images.push(imageObj);
      viewGroups.push(newObj);
    } else {
      const imageObj = {
        id: parseInt(image.imageset_id, 10),
        src: rootState.project.assetsUrl + image.url,
        caption: image.caption,
        isPano: false
      };
      existingViewGroup.images.push(imageObj);
    }
  });
  commit('setViewList', viewGroups);
};

export default {
  populateData
};



// WEBPACK FOOTER //
// ./src/store/modules/floorplans/views/actions.js